<template>
  <div class="quote-grid">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-sm-12 col-12" v-for="item in quotes" :key="item.id">
          <quote-block :quote="item" v-on:add-heart="onAddHeart($event, item)"></quote-block>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import QuoteBlock from '@/components/Single/QuoteBlock'
  import firestore from '../../firebaseInit';

  export default {
    name: 'QuoteGrid',
    components: {
      QuoteBlock
    },
    data: function () {
      return {
        quotes: [],
        quote: {
          hearts: 233,
          p: ' He who fights with monsters should look to it that he himself does not become a monster. \
        And if you gaze long into an abyss, the abyess will also gae into thee. ',
          author: 'friderich nietsche',
          contributor: '@wlfp from Devhub'
        },
        quote2: {
          hearts: 332,
          p: ' He who fights with monsters should look to it that he himself does not become a monster. \
        And if you gaze long into an abyss, the abyess will also gae into thee. ',
          author: 'friderich nietsche',
          contributor: '@wlfp from Devhub'
        }
      }
    },
    created() {
      firestore.collection('quotes').get().then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            'id': doc.data().id,
            'content': doc.data().content,
            'hearts': doc.data().hearts,
            'author': doc.data().author,
            'contributor': doc.data().contributor,
            'socialUrl': doc.data().socialUrl
          }
          console.log(data)
          this.quotes.push(data)
        })
      })
    },
    methods: {
      onAddHeart: function (event, item) {
        item.hearts += event
        //update heart count with firebase api 
        firestore.collection('quotes').where('id', '==', item.id).get()
          .then(querySnapshot => {
            querySnapshot.forEach(doc => {
              doc.ref.update({
                hearts: item.hearts
              })
            })
          }).then(() => {
            console.log('success')
          })
          .catch(error => console.error(error))
      }
    }
  }
</script>